import * as Sentry from '@sentry/react';

export const captureError = Sentry.captureException;
